var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 550,
    height: 550,
    viewBox: "0 0 550 550",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "0lojo8bcxa",
    d: "M0 0.117L439.245 0.117 439.245 478 0 478z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF597",
    d: "M81.153 386.021L230.214 435.708 360.529 386.84 394.938 42.768 46.825 42.768z",
    transform: "translate(55 47)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(55 47) translate(0 .883)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "4vuxj0rcub",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0lojo8bcxa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2E036A",
    d: "M52.924 404.166l171.815 56.361 161.573-56.253L421.44 17.117H17.805l35.119 387.049zM224.82 478c-.894 0-1.788-.141-2.65-.424l-179.856-59c-3.223-1.056-5.51-3.93-5.815-7.308L.035 9.385c-.216-2.378.578-4.738 2.188-6.501C3.833 1.121 6.112.117 8.5.117h422.246c2.388 0 4.666 1.004 6.276 2.767 1.61 1.763 2.405 4.123 2.189 6.501l-36.464 401.883c-.301 3.323-2.52 6.163-5.67 7.259l-169.462 59c-.904.316-1.85.473-2.795.473z",
    mask: "url(#4vuxj0rcub)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2E036A",
    d: "M209.568 368.394c-.815 0-1.635-.117-2.435-.356l-69.191-20.696c-3.039-.909-5.319-3.433-5.914-6.55l-9.899-51.901c-.879-4.612 2.145-9.063 6.756-9.942 4.61-.882 9.063 2.144 9.943 6.756l8.931 46.83 53.31 15.945V120.07l-99.767-.027c-4.694-.002-8.498-3.808-8.498-8.503 0-4.694 3.807-8.498 8.5-8.498h.002l108.265.03c4.694.001 8.498 3.806 8.498 8.5v248.322c0 2.686-1.27 5.214-3.423 6.817-1.485 1.106-3.269 1.683-5.078 1.683M252.74 368.397c-3.52 0-6.81-2.202-8.03-5.714-1.54-4.433.806-9.277 5.24-10.817l51.529-17.897 18.484-98.274H252.74c-4.694 0-8.5-3.806-8.5-8.5V111.573c0-4.695 3.806-8.5 8.5-8.5h98.17c2.694 0 5.229 1.277 6.832 3.443 1.603 2.165 2.084 4.963 1.297 7.54l-10.646 34.837c-1.372 4.49-6.122 7.02-10.613 5.645-4.49-1.371-7.017-6.123-5.645-10.614l7.29-23.852H261.24v98.623h68.97c2.53 0 4.928 1.126 6.543 3.073 1.615 1.946 2.279 4.512 1.81 6.998l-21.288 113.188c-.563 2.993-2.686 5.457-5.564 6.457l-56.182 19.512c-.923.322-1.864.474-2.79.474",
    transform: "translate(55 47) translate(0 .883)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJs);
export default __webpack_public_path__ + "static/media/icon--js.8aa0a0de5b22704b304f1e13ae9d834c.svg";
export { ForwardRef as ReactComponent };